import React from 'react';

import { Radio } from 'components';
import { useTranslation } from 'react-i18next';

import { ProductType } from 'lane-shared/domains/billingPayments/types';

import styles from '../addProductToChargeStyles.scss';

const requiredFieldAsteriskSymbol = '*';

export function AddProductRadioGroup({
  productType,
  updateProductType,
}: {
  productType: ProductType;
  updateProductType: (value: string) => void;
}) {
  const { t } = useTranslation();

  return (
    <div>
      <label className={styles.descriptionLabel}>
        {t('abp.productsServices.createProduct.typeLabel')}{' '}
        <span className={styles.InputLabelRequiredAstrisk}>
          {requiredFieldAsteriskSymbol}
        </span>
      </label>
      <Radio
        testId="materialRadioButton"
        text="abp.productsServices.createProduct.type.material"
        value={ProductType.PRODUCT_TYPE_SERVICE_MATERIALS}
        selected={productType}
        onChange={updateProductType}
      />
      <Radio
        testId="laborRadioButton"
        text="abp.productsServices.createProduct.type.labor"
        value={ProductType.PRODUCT_TYPE_SERVICE_LABOUR}
        selected={productType}
        onChange={updateProductType}
      />
    </div>
  );
}
